import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Typography,
  TextField,
  List,
  ListItem,
  ListItemAvatar,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Snackbar,
  Alert
} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  getBatchWithResults,
  getBatchWithOutResults,
  getReportsApi,
  getClientDetailsApi,
  getContactEmailApi,
  getEmailContent,
  stripeCheckout,
  getClientInfo,
  stripeCheckoutIsEligible
} from 'services';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import moment from 'moment';
import Link from '@mui/material/Link';
import pdf from '../../assets/icons/pdf.gif';
import report from '../../assets/icons/report.gif';
import AC from '../../assets/icons/AC.gif';
import Air from '../../assets/icons/air.gif';
import Biota from '../../assets/icons/biota.gif';
import C from '../../assets/icons/c.gif';
import DA from '../../assets/icons/DA.gif';
import DL from '../../assets/icons/DL.gif';
import Doc from '../../assets/icons/doc.gif';
import DS from '../../assets/icons/DS.gif';
import DW from '../../assets/icons/DW.gif';
import FA from '../../assets/icons/FA.gif';
import FC from '../../assets/icons/FC.gif';
import ID from '../../assets/icons/ID.gif';
// import Invoice from '../../assets/icons/invoice.gif';
import IS from '../../assets/icons/IS.gif';
import Leachate from '../../assets/icons/leachate.gif';
import Merge from '../../assets/icons/merge.gif';
import ML from '../../assets/icons/ML.gif';
import OH from '../../assets/icons/OH.gif';
import Soil from '../../assets/icons/soil.gif';
import To from '../../assets/icons/TO.gif';
import Water from '../../assets/icons/water.gif';
import Xls from '../../assets/icons/xls.gif';
import PDF from '../../assets/icons/pdf.svg';
import Invoice from '../../assets/icons/invoice.svg';
import axios from 'axios';
import { getErrorMessage } from 'helpers/apiErrorEvent';
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import useFetch from 'modules/customHooks/useFetch';
import { ClientNameDropdown } from 'modules/quote/custom_component/clientNameDropdown';
import PaymentIcon from '@mui/icons-material/Payment';
import { useSearchParams } from 'react-router';
import { InactivityWarningPopup } from './components';
import { calculateDaysLeftBeforeLock } from 'helpers/inactivityHelper';

const Demo = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

let rowItemStatus = false;
interface IFormInput {
  reportNo: string
  startDate: string
  endDate: string
  invoiceNo: string
  site: string
}

let clientInfoCheck: any = {};

export const Home = () => {
  const [rightEnable, setRightEnable] = useState(false);
  const [isDownloadReport, setIsDownloadReport] = useState(false);
  const [expanded, setExpanded] = useState<string | false>(false);
  const [clientResult, setClientResult] = useState([] as any[]);
  const [clientDetails, setClientDetails] = useState([] as any[]);
  const [emailDetails, setEmailDetails] = useState([] as any[]);
  const [emailContent, setEmailContent] = useState('');
  const [reportList, setReportList] = useState({
    reports: [],
    batchID: '',
    batchProjectID: '',
    batchProjectName: ''
  });
  const [batchId, setBatchId] = useState<Array<string | number>>([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const dataRef = useRef(clientResult);
  const [userInfo] = useFetch();
  const { control, reset, handleSubmit } = useForm({
    defaultValues: {
      reportNo: "",
      startDate: "",
      endDate: "",
      invoiceNo: "",
      site: "",
    },
  });
  const [selectedClientId, setSelectedClientId] = useState('');
  const [isArchive, setIsArchive] = useState(null);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [emptyError, setEmptyError] = useState(false);
  const [paymentButtonEnable, setPaymentButtonEnable] = useState(false);
  const [paymentMessage, setPaymentMessage] = useState<string>("");
  const [showInactivityWarning, setShowInactivityWarning] = useState(false);
  const [daysLeftBeforeLock, setDaysLeftBeforeLock] = useState(60);
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('clientID');

  const queryParams = new URLSearchParams(window.location.search);
  const batchIdFromUrl = queryParams.get('batchID');

  const jwt: any = localStorage.getItem('token');
  const labUserCheck: any = jwt ? JSON.parse(atob(jwt.split('.')[1])) : null;
  const [page, setPage] = useState(0);
  const pageSize = 10;

  const handleCheckout = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      let obj = {
        batchID: batchId[0],
        isArchive: isArchive === 1 ? true : false,
        clientID: selectedClientId
      }
      const response = await stripeCheckout(obj);
      if (response.status === 200) {
        const locationUrl = response.data;
        if (locationUrl) {
          window.location.href = locationUrl;
        }
      } else {
        setPaymentButtonEnable(false);
        setError(true);
        setErrorMessage(getErrorMessage({ response }, 'Payment setup failed. Please try again.'));
      }
    } catch (err: any) {
      setPaymentButtonEnable(false);
      setError(true);
      setErrorMessage(getErrorMessage(err, 'Payment setup failed. Please contact support.'));
    }
  };

  useEffect(() => {
    if (!userInfo?.userMap || labUserCheck?.UserType === 'Internal') return;

    if (clientId) {
      setSelectedClientId(String(clientId));
      return;
    }

    // Keep whatever is already selected (e.g. picked on another page) instead of resetting to the first client
    const hasValidSelection = selectedClientId &&
      userInfo.userMap.some((client: any) => String(client.clientID) === String(selectedClientId));
    if (hasValidSelection) return;

    const savedClientId = localStorage.getItem('selectedClientId');
    const savedClient = savedClientId && userInfo.userMap.find((client: any) => String(client.clientID) === savedClientId);
    const defaultClient = savedClient || userInfo.userMap[0];
    if (defaultClient) {
      setSelectedClientId(String(defaultClient.clientID));
    }
  }, [userInfo?.userMap, clientId, labUserCheck?.UserType, selectedClientId]);

  useEffect(() => {
    if (labUserCheck?.UserType === 'External') {
      // Calculate days left based on last login from JWT token
      const lastLoginDate = labUserCheck?.auth_time 
        ? new Date(labUserCheck.auth_time * 1000).toISOString() 
        : undefined;
      
      const daysLeft = calculateDaysLeftBeforeLock(lastLoginDate);
      setDaysLeftBeforeLock(daysLeft);
      
      // Check if user has dismissed the popup
      const isDismissed = localStorage.getItem('inactivityWarningDismissed');
      
      // Check URL params for force show (for testing)
      const urlParams = new URLSearchParams(window.location.search);
      const forceShowPopup = urlParams.get('showInactivityPopup') === 'true';
      
      // Show popup if not dismissed OR if forced via URL parameter
      if (!isDismissed || forceShowPopup) {
        setShowInactivityWarning(true);
      }
    }
  }, [labUserCheck?.UserType, labUserCheck?.auth_time]);

  const handleCloseInactivityWarning = () => {
    setShowInactivityWarning(false);
  };

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const DownloadAllReport = async (data: any) => {
    const token = localStorage.getItem('token');

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/FileShare/GetZippedClientReports`, // Adjust endpoint as needed
        data,
        {
          responseType: 'arraybuffer', // Important for binary data
          headers: {
            'Authorization': token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json'
          }
        }
      );

      return response;
    } catch (error) {
      throw error;
    }
  };

  const downloadAllReports = async () => {
    if (reportList?.reports?.length > 0) {
      let fileNames: any = [];
      let fileShareName = '';
      reportList.reports.forEach((report: any, index: number) => {
        fileNames.push(report.fileName);
        fileShareName = report.fileShareName;
      });

      let Obj = {
        "fileShareName": fileShareName,
        "clientId": selectedClientId,
        "batchId": reportList?.batchID,
        "batchProjectID": reportList?.batchProjectID,
        "batchProjectName": reportList?.batchProjectName,
        "fileNames": fileNames
      };

      try {
        const response = await DownloadAllReport(Obj);

        if (response.status === 200) {
          let filename = `${reportList?.batchID}_${reportList?.batchProjectName}${reportList?.batchProjectID}.zip`;
          const contentTypeHeader = response.headers['content-type'];
          const contentType = typeof contentTypeHeader === 'string'
            ? contentTypeHeader
            : 'application/zip';

          const blob = new Blob([response.data], {
            type: contentType
          });

          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          setIsDownloadReport(true);
        } else {
          setError(true);
          setErrorMessage(getErrorMessage({ response }, 'Failed to download files. Please try again.'));
        }
      } catch (error: any) {
        setError(true);
        setErrorMessage(getErrorMessage(error, 'Download failed. Please contact support.'));
      }
    }
  };

  const renderStatusField = (props: any) => {
    const { row } = props;
    return (
      <div> {row.isCompleted ? 'Completed' : 'In-Progress'} </div>
    );
  }

  const renderDateReceivedField = (props: any) => {
    const { row } = props;
    return (
      <div> {moment(row.dateReceived).format("DD/MM/YYYY")} </div>
    );
  }

  const renderDueDateField = (props: any) => {
    const { row } = props;
    return (
      <div> {moment(row.dueDate).format("DD/MM/YYYY")} </div>
    );
  }

  const renderSite = (props: any) => {
    const { row } = props;
    return (
      <div style={{ overflowY: 'scroll' }}> {row.site} </div>
    );
  }

  const columns: GridColDef[] = [
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 100,
      renderCell: renderStatusField
    },
    {
      field: 'id',
      headerName: 'Report No',
      maxWidth: 80,
    },
    {
      field: 'dateReceived',
      headerName: 'Date Received',
      minWidth: 80,
      renderCell: renderDateReceivedField
    },
    {
      field: 'dueDate',
      headerName: 'Date Due',
      minWidth: 80,
      renderCell: renderDueDateField
    },
    {
      field: 'invoiceNumber',
      headerName: 'Invoice',
      maxWidth: 80,
    },
    {
      field: 'site',
      headerName: 'Site',
      minWidth: 500,
      renderCell: renderSite
    }
  ];

  useEffect(() => {
    getGridLoadResult();
    getClientInfoApi();
  }, [selectedClientId])

  useEffect(() => {
    dataRef.current = clientResult;
  });

  useEffect(() => {
    if (dataRef.current && dataRef.current.length > 0) {
      if (!selectionModel || selectionModel.length === 0) {
        if (batchIdFromUrl) {
          const matchedIndex = dataRef.current.findIndex(row => String(row.id) === String(batchIdFromUrl));
          if (matchedIndex !== -1) {
            setSelectionModel([dataRef.current[matchedIndex].id]);
            setPage(Math.floor(matchedIndex / pageSize));
            return;
          }
        }
        setSelectionModel([dataRef.current[0].id]);
        setPage(0);
      }
    }
  }, [dataRef.current, window.location.search, selectionModel]);

  const handleRowClick = (params: any) => {
    const isArchiveValue = params?.row?.isArchive;
    setIsArchive(isArchiveValue);
    getReports(params?.row?.id, isArchiveValue);
    getClientDetails(params?.row?.id, isArchiveValue);
    getContactEmail(params?.row?.id, isArchiveValue);
    stripeCheckoutIsEligibleApi(params?.row?.id, isArchiveValue);
    window.history.replaceState(null, '', '/home');
  }

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    if (data?.reportNo !== '' || data?.startDate !== '' || data?.endDate !== '' || data?.invoiceNo !== "" || data?.site !== '') {
      getBatchResult(data);
    } else {
      getGridLoadResult();
    }
  }

  const getGridLoadResult = () => {
    if (labUserCheck?.UserType !== 'Internal' && selectedClientId) {
      getBatchWithOutResults(selectedClientId).then((res: any) => {
        if (res.status === 200) {
          setClientResult(res.data);
          defaultLoadResult(res.data);
        } else{
          setClientResult([]);
          defaultLoadResult([]);
        }
      }).catch((err: any) => {
        setClientResult([]);
        defaultLoadResult([]);
      });
    }
  }

  const getClientInfoApi = () => {
    if (labUserCheck?.UserType !== 'Internal' && selectedClientId) {
      getClientInfo(selectedClientId).then((res: any) => {
        if (res.status === 200) {
          clientInfoCheck = res?.data;
          if (clientInfoCheck?.billingStatus == 0) {
            stripeCheckoutIsEligibleApi(batchId, isArchive);
          }
        }
      })
    }
  }

  const stripeCheckoutIsEligibleApi = (batchId: any, isArchive: any) => {
    const hasValidBatchId = Array.isArray(batchId)
      ? batchId.filter((id) => id !== undefined && id !== null && id !== '').length > 0
      : batchId !== undefined && batchId !== null && batchId !== '';
    if (labUserCheck?.UserType !== 'Internal' && clientInfoCheck?.billingStatus == 0 && hasValidBatchId) {
      let isArchiveValue = isArchive === 1 ? true : false;
      stripeCheckoutIsEligible(batchId, isArchiveValue).then((res: any) => {
          if (res.status === 200) {
            if (res.data == 'Payment is Pending') {
              setPaymentButtonEnable(true);
              setPaymentMessage("");
            } else if (res.data === '') {
              setPaymentButtonEnable(false);
              setPaymentMessage("");
            } else {
              setPaymentButtonEnable(false);
              setPaymentMessage(res.data);
            }
          } else if (res.status === 409) {
            setPaymentButtonEnable(false);
            setPaymentMessage(res?.data);
          }
        })
    }
  }

  const settingId = (id: any) => {
    setBatchId(id);
  }

  const defaultLoadResult = (val: any) => {
    let batchId = batchIdFromUrl ? batchIdFromUrl : val[0]?.id;
    let isArchiveValue = batchIdFromUrl ? false : val[0]?.isArchive;
    stripeCheckoutIsEligibleApi(batchId, isArchiveValue);
    getReports(batchId, isArchiveValue);
    getClientDetails(batchId, isArchiveValue);
    getContactEmail(batchId, isArchiveValue);
    setIsArchive(isArchiveValue);
    setRightEnable(val.length > 0);
    let ids = [];
    ids.push(batchId);
    onRowsSelectionHandler(ids, val);
    if (batchIdFromUrl === null || batchIdFromUrl === '' || batchIdFromUrl === undefined) {
      setSelectionModel(batchId);
    }
    settingId(ids);
  }

  const getBatchResult = (item: any) => {
    getBatchWithResults(selectedClientId, item?.reportNo, item?.invoiceNo, item?.startDate, item?.endDate, item?.site).then((res: any) => {
      if (res.status === 200) {
        if (res.data.length > 0) {
          setClientResult(res.data);
          defaultLoadResult(res.data);
        } else {
          setEmptyError(true);
          setClientResult([]);
          defaultLoadResult([]);
        }
      }
    }).catch((err: any) => {
      setClientResult([]);
      defaultLoadResult([]);
    });
  }

  const getReports = (id: any, isArchive: any) => {
    if (id) {
      getReportsApi(id, isArchive === 1).then((res: any) => {
        if (res.status === 200) {
          setReportList(res.data);
        }
      })
    }
  }

  const getClientDetails = (id: any, isArchive: any) => {
    if (id) {
      getClientDetailsApi(id, isArchive === 1).then((res: any) => {
        if (res.status === 200) {
          let item: any = [];
          item.push(res.data);
          setClientDetails(item);
        }
      })
    }
  }

  const getContactEmail = (id: any, isArchive: any) => {
    setEmailDetails([]);
    if (id) {
      getContactEmailApi(id, isArchive === 1).then((res: any) => {
        if (res.status === 200) {
          setEmailDetails(res.data);
        }
      })
    }
  }

  const getFileFromApi = (item: any) => {
    const token = localStorage.getItem('token');
    let params = {
      "fileName": item.fileName,
      "fileShareName": item.fileShareName,
      "clientId": selectedClientId
    }
    axios.post(`${process.env.REACT_APP_BASE_URL}/FileShare/GetFile`, params,
      {
        responseType: 'arraybuffer',
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          "content-type": "application/json"
        }
      }
    ).then((response) => {
      setIsDownloadReport(true);
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', item.fileName);
      document.body.appendChild(link);
      link.click();

    }).catch(function (error) {
      setError(true);
      setErrorMessage(getErrorMessage(error, 'Something went wrong! Please contact Administrator.'));
    });
  }

  const getEmailContentDetails = (eId: any, isArchive: any) => {
    if (eId) {
      getEmailContent(eId, isArchive === 1).then((res: any) => {
        if (res.status === 200) {
          setEmailContent(res.data);
        }
      })
    }
  }

  const loadIcons = (items: any) => {
    let path: any = '';
    if (items?.iconName === 'report.gif' || items?.iconName === 'coc.gif') {
      path = PDF;
    } else if (items?.iconName === 'pdf.gif') {
      path = pdf;
    } else if (items?.iconName === 'AC.gif') {
      path = AC;
    } else if (items?.iconName === 'air.gif') {
      path = Air;
    } else if (items?.iconName === 'biota.gif') {
      path = Biota;
    } else if (items?.iconName === 'c.gif') {
      path = C;
    } else if (items?.iconName === 'DA.gif') {
      path = DA;
    } else if (items?.iconName === 'DL.gif') {
      path = DL;
    } else if (items?.iconName === 'doc.gif') {
      path = Doc;
    } else if (items?.iconName === 'DS.gif') {
      path = DS;
    } else if (items?.iconName === 'DW.gif') {
      path = DW;
    } else if (items?.iconName === 'FA.gif') {
      path = FA;
    } else if (items?.iconName === 'FC.gif') {
      path = FC;
    } else if (items?.iconName === 'ID.gif') {
      path = ID;
    } else if (items?.iconName === 'invoice.gif') {
      path = Invoice;
    } else if (items?.iconName === 'IS.gif') {
      path = IS;
    } else if (items?.iconName === 'leachate.gif') {
      path = Leachate;
    } else if (items?.iconName === 'merge.gif') {
      path = Merge;
    } else if (items?.iconName === 'ML.gif') {
      path = ML;
    } else if (items?.iconName === 'OH.gif') {
      path = OH;
    } else if (items?.iconName === 'soil.gif') {
      path = Soil;
    } else if (items?.iconName === 'TO.gif') {
      path = To;
    } else if (items?.iconName === 'water.gif') {
      path = Water;
    } else {
      path = Xls
    }
    return <img src={path} alt="" width="20px" />
  }

  const onRowsSelectionHandler = (ids: any, item: any) => {
    const selectedItem = ids.map((id: any) => item.find((row: any) => row.id === id));
    selectedItem?.map((i: any) => {
      rowItemStatus = i?.isCompleted;
    })
  };

  const reactHtml = () => {
    return <div dangerouslySetInnerHTML={{ __html: emailContent }} style={{ height: '300px', overflow: 'scroll' }}>
    </div>
  }

  const renderAttachments = (val: any) => {
    return <div style={{ height: '100px', overflowY: 'scroll', fontSize: '12px' }}>{
      val?.map((i: any, index: any) => {
        return <li key={index}>{i}</li>
      })
    }
    </div>
  }

  return (
    <Box sx={{ flexGrow: 1, padding: '16px 16px' }}>
      <InactivityWarningPopup
        open={showInactivityWarning}
        onClose={handleCloseInactivityWarning}
        daysLeft={daysLeftBeforeLock}
      />
      {(userInfo && userInfo.userType !== 'Internal') ?
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', boxShadow: 'none', border: '1px solid #ddd' }}>
              <CardContent>
                <div>
                  {userInfo ?
                    <ClientNameDropdown
                      selectedClientId={selectedClientId}
                      setSelectedClientId={setSelectedClientId}
                      pageName="home"
                      setPage={setPage}
                    />
                    : null}
                  <hr />
                  <form onSubmit={handleSubmit(onSubmit)} style={{ marginBottom: '16px', backgroundColor: '#f5f5f5', padding: '24px', borderRadius: '6px' }}>
                    <Grid container spacing={2}>
                      <Grid item xs={4} sm={4} md={4}>
                        <Controller
                          name="reportNo"
                          control={control}
                          render={({ field }) => <TextField
                            label="Report No"
                            sx={{
                              '.MuiInputLabel-root': {
                                fontSize: '12px'
                              },
                              width: '100%'
                            }}
                            size="small"
                            {...field}
                          />}
                        />
                      </Grid>
                      <Grid item xs={4} sm={4} md={4}>
                        <Controller
                          name="startDate"
                          control={control}
                          render={({ field }) => <TextField
                            id="date"
                            type="date"
                            fullWidth
                            label="Start Date"
                            sx={{
                              '.MuiOutlinedInput-root': {
                                fontSize: '12px'
                              },
                              width: '100%'
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            size="small"
                            {...field}
                          />}
                        />
                      </Grid>
                      <Grid item xs={4} sm={4} md={4}>
                        <Controller
                          name="endDate"
                          control={control}
                          render={({ field }) => <TextField
                            id="date"
                            type="date"
                            fullWidth
                            label="End Date"
                            sx={{
                              '.MuiOutlinedInput-root': {
                                fontSize: '12px'
                              },
                              width: '100%'
                            }}
                            size="small"
                            style={{ width: '100%' }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            {...field}
                          />}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={6} sm={6} md={6} lg="auto">
                        <Controller
                          name="invoiceNo"
                          control={control}
                          render={({ field }) => <TextField
                            label="Invoice No"
                            sx={{
                              '.MuiOutlinedInput-root': {
                                fontSize: '12px'
                              },
                              width: '100%'
                            }}
                            size="small"
                            {...field}
                          />}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={6} lg="auto">
                        <Controller
                          name="site"
                          control={control}
                          render={({ field }) => <TextField
                            label="Site"
                            sx={{
                              '.MuiInputLabel-root': {
                                fontSize: '12px'
                              },
                              width: '100%'
                            }}
                            size="small"
                            {...field}
                          />}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={12} lg="auto" sx={{ mt: { xs: 2, sm: 1, md: 0 } }}>
                        <Button variant="contained" color="primary" type="submit" startIcon={<ContentPasteSearchOutlinedIcon />}>Search</Button> &nbsp;&nbsp;
                        <Button variant="outlined" color="primary" startIcon={<ClearOutlinedIcon />} onClick={() => {
                          reset();
                          getGridLoadResult();
                          setIsArchive(null);
                        }}>Clear All</Button>
                      </Grid>
                    </Grid>
                  </form>
                </div>
                {clientResult?.length > 0 ?
                  <DataGrid
                    autoHeight
                    sx={{
                      '.MuiDataGrid-columnHeaders': {
                        backgroundColor: '#003883',
                        color: '#fff'
                      },
                      '.MuiDataGrid-columnHeaders .MuiCheckbox-root': {
                        color: '#fff'
                      },
                      '.MuiDataGrid-menuIcon .MuiSvgIcon-root': {
                        color: '#fff'
                      },
                      '.MuiDataGrid-iconButtonContainer .MuiSvgIcon-root': {
                        color: '#fff'
                      },
                      '.MuiDataGrid-columnSeparator--sideRight': {
                        display: 'none'
                      },
                      '.MuiDataGrid-cell:focus': {
                        outline: 'none'
                      },
                      '.MuiDataGrid-row:hover': {
                        backgroundColor: '#00388324'
                      },
                      '.MuiDataGrid-row': {
                        cursor: 'pointer'
                      },
                      fontSize: '12px'
                    }}
                    columns={columns}
                    rows={clientResult}
                    onSelectionModelChange={(ids: any, newSelection: any) => {
                      const arrIds = Array.isArray(ids) ? ids : [ids];
                      setRightEnable(true);
                      onRowsSelectionHandler(arrIds, clientResult);
                      setBatchId(arrIds);
                      setSelectionModel(arrIds);
                    }}
                    onRowClick={handleRowClick}
                    page={page}
                    onPageChange={(newPage) => setPage(newPage)}
                    pageSize={pageSize}
                    rowsPerPageOptions={[10]}
                    selectionModel={selectionModel}
                    checkboxSelection={false}
                    experimentalFeatures={{ newEditingApi: true }}
                  /> : null}
              </CardContent>
            </Card>
          </Grid>
          {rightEnable ?
            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%', boxShadow: 'none', border: '1px solid #ddd' }}>
                <CardContent>
                  {clientDetails?.map((j: any, index: any) => {
                    return <div key={index}>
                      <Typography gutterBottom variant="h6" component="div">
                        Report Viewer
                      </Typography>
                      <hr />
                      {!rowItemStatus ?
                        <Typography variant="subtitle1" mt={2} mb={2}>
                          <strong>The report for job {batchId.length > 0 ? batchId : ''} has not yet been authorised by a NATA signatory or issued to the client.
                            As such any results present are to be considered preliminary and subject to change, and should not be actioned upon.</strong>
                        </Typography>
                        : null}
                      <Typography variant="subtitle1" mt={2} mb={2}>
                        Select the information that you want to view from the list below. If you want to download a file, click on the link and select 'Save as' from the list that pops up.</Typography>
                      <Typography variant="subtitle1" mt={2} mb={2}>
                        Analytical Services Manager for this report is <strong>{j.firstname} {j.lastname}</strong> If you have any enquiries regarding this information, please call {j.telephone} or email {j.email}.
                      </Typography>
                    </div>
                  })}
                  {clientInfoCheck?.billingStatus === 0 ?
                    <>
                      {paymentMessage.length > 0 || paymentButtonEnable ?
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 2,
                          mt: 2,
                          mb: 2,
                          background: '#e3f2fd',
                          borderRadius: '6px',
                          padding: { md: '12px 0px', sm: '12px 16px' },
                          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}>
                          {paymentMessage.length > 0 && <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1976d2' }}>
                            {paymentMessage}
                          </Typography>}
                          {paymentButtonEnable ?
                            <Button
                              variant="contained"
                              color="primary"
                              startIcon={<PaymentIcon />}
                              onClick={handleCheckout}
                              sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                marginLeft: { md: '6px' }
                              }}
                            >
                              Proceed to Payment
                            </Button> : null}
                        </Box>
                        : null}
                    </>
                    : null}
                  <div style={{ paddingTop: '20px' }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={5} lg={4}>
                        <Typography gutterBottom variant="h6" component="div">
                          Report Information
                        </Typography>
                        <hr />
                        <div>
                          {reportList?.reports?.length > 0 && (
                            <Button
                              variant="contained"
                              color="primary"
                              startIcon={<DownloadIcon />}
                              onClick={downloadAllReports}
                              size="small"
                              sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: { xs: '12px', sm: '12px' },
                                whiteSpace: 'nowrap',
                                padding: { xs: '4px 10px', sm: '6px 16px' },
                                marginLeft: { md: '6px' }
                              }}
                            >
                              Download All
                            </Button>
                          )}
                          <Grid container spacing={2}>
                            {reportList?.reports?.length > 0 ?
                              <Grid item xs={12} md={12}>
                                <Demo sx={{ height: '500px', overflowY: 'scroll', textAlign: 'left' }}>
                                  <List>
                                    {reportList?.reports.map((i: any, index: any) => {
                                      return <ListItem key={index}>
                                        <ListItemAvatar>
                                          {loadIcons(i)}
                                        </ListItemAvatar>
                                        <Link
                                          component="button"
                                          variant="body2"
                                          sx={{ textAlign: 'left' }}
                                          onClick={() => getFileFromApi(i)}
                                        >
                                          {i.fileDisplayName}
                                        </Link>
                                      </ListItem>
                                    })}
                                  </List>
                                </Demo>
                              </Grid> : null}
                          </Grid>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={7} lg={8}>
                        <Typography gutterBottom variant="h6" component="div">
                          Email History
                        </Typography>
                        <hr />
                        {emailDetails?.map((i: any, index: any) => {
                          return <Accordion
                            sx={{
                              '.MuiAccordionSummary-expandIconWrapper': {
                                display: 'none'
                              }
                            }}
                            expanded={expanded === i.id} onChange={handleChange(i.id)} onClick={() => getEmailContentDetails(i.id, isArchive)}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id={i.id}
                            >
                              <Typography sx={{ width: '33%', flexShrink: 0, fontSize: '12px' }}>
                                {moment(i.dateSent).format("DD/MM/YYYY")}
                              </Typography>
                              <Typography sx={{ color: 'text.secondary' }}>
                                <Link
                                  component="button"
                                  variant="subtitle1"
                                  onClick={() => getEmailContentDetails(i.id, isArchive)}
                                >{i.name}</Link></Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ border: '1px solid #ddd', margin: '14px', boxShadow: '5px 10px #ddd' }}>
                              <Typography variant="subtitle1" gutterBottom mt={2} mb={2} align="center"> <strong>Report Delivery Email</strong> </Typography>
                              <Typography variant="subtitle1" mt={2} mb={2}> <strong>Sent to :</strong> {i.deliveryMethod.id === 0 ? i.name : `Sent Via ${i.deliveryMethod.name}`}</Typography>
                              <Typography variant="subtitle1" mt={2} mb={2}> <strong>CC :</strong> </Typography>
                              <Typography variant="subtitle1" mt={2} mb={2}> <strong>Date :</strong> {moment(i.dateSent).format("DD/MM/YYYY")}</Typography>
                              <Typography variant="subtitle1" mt={2} mb={2}> <strong>Sent From :</strong> {i.sentFrom}</Typography>
                              <Typography variant="subtitle1" mt={2} mb={2} sx={{ overflow: 'auto' }}> <strong>Message :</strong><article>
                                {reactHtml()}
                              </article></Typography>
                              <Typography variant="subtitle1" sx={{ overflow: 'auto' }}> <strong>Attachments :</strong> <br />
                                {renderAttachments(i.attachments)}
                              </Typography>
                            </AccordionDetails >
                          </Accordion>
                        })}
                      </Grid>
                    </Grid>
                  </div>
                </CardContent>
              </Card>
            </Grid>
            : null
          }
        </Grid >
        : <></>}
      <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
        <Snackbar open={isDownloadReport} autoHideDuration={6000} onClose={() => setIsDownloadReport(false)}>
          <Alert severity="success" onClose={() => setIsDownloadReport(false)}><b>Downloading the document.</b></Alert>
        </Snackbar>
        <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
          <Alert severity="error" onClose={() => setError(false)}><b>{errorMessage}</b></Alert>
        </Snackbar>
        <Snackbar open={emptyError} autoHideDuration={6000} onClose={() => setEmptyError(false)}>
          <Alert severity="warning" onClose={() => setEmptyError(false)}><b>No records found!</b></Alert>
        </Snackbar>
      </Stack>
    </Box >
  );
}
